<template>
  <the-page :pageId="pageId" :appConfig="appConfig" embeddedMode>
    <page-block
      v-for="(block, index) of blocks"
      :key="`${pageId}${block}`"
      :entityType="block"
      :blockTitle="blockTitle"
      :showSidebarButton="index === 0"
      :appConfig="appConfig"
      :blockConfig="menuItem.pageblocks[index]"
      @entityClick="editEntity"
    />

    <a-modal
      width="1170px"
      :visible="showModal"
      :bodyStyle="modalBodyStyle"
      :title="null"
      :footer="null"
      :closable="false"
      transitionName="none"
      maskTransitionName="none"
      @cancel="closeModalEditing"
    >
      <div class="entity-modal">
        <component
          :is="modalComponent"
          v-if="showModal"
          :id="editedEntity.id"
          :type="editedEntity.type"
          :visibleTabs="tabs"
          @editingEntityIdChanged="editingEntityIdChanged"
          @close="closeModalEditing"
        />
      </div>
    </a-modal>
  </the-page>
</template>

<script>
import store from '@/store';
import PhrasesModal from '@/components/phrases-modal/PhrasesModal.vue';
import ThePage from '@/components/page/ThePage.vue';
import PageBlock from './pageblock/PageBlock.vue';

export default {
  name: 'TheTablePage',

  components: {
    PageBlock,
    ThePage,
    PhrasesModal,
  },

  props: {
    config: {
      type: Object,
      default: null,
    },
    appConfig: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      pageId: this.$route.params.type,
      showModal: false,
      editedEntity: null,
    };
  },

  computed: {
    menuItem() {
      return store.state.activeSidebarItem;
    },
    linkedComponent() {
      return this.menuItem?.customprops?.tableRowLinkedComponent;
    },
    modalComponent() {
      return this.menuItem?.customprops?.tableRowCustomModal?.component;
    },
    tabs() {
      return this.menuItem?.customprops?.tabs;
    },
    blocks() {
      if (this.menuItem === undefined) return [];
      const code = this.menuItem.pageblocks?.[0]?.entityId || this.pageId;
      return code ? [code] : [];
    },
    blockTitle() {
      if (store.state.activeSidebarItem === undefined) return undefined;
      return store.state.activeSidebarItem.title || null;
    },
    modalBodyStyle() {
      return {
        height: '80vh',
        maxWidth: '1170px',
        width: '100%',
        backgroundColor: '#f9f9f9',
      };
    },
  },

  watch: {
    $route(to) {
      if (to.name === 'TablePage') {
        this.pageId = to.params.type;
      } else {
        this.pageId = null;
      }
    },
  },
  methods: {
    editEntity(type, id, meta, data) {
      if (this.modalComponent) {
        this.showModal = true;
        this.editedEntity = { type, id };
      } else if (this.linkedComponent) {
        this.$router.push({
          name: 'DataMarking',
          params: {
            type: this.pageId,
            category: data.name,
          },
        });
      } else {
        this.$emit('editEntity', type, id, meta);
      }
    },
    closeModalEditing() {
      this.showModal = false;
      this.editedEntity = null;
    },
    editingEntityIdChanged(id) {
      this.editedEntity.id = id;
    },
  },
};
</script>
